import { ChevronLeft, ChevronRight } from "lucide-react";
const Pagination = ({ currentPage, totalPages, onPageChange }) => (
  <div className="flex items-center justify-center gap-2 mt-6">
    <button
      onClick={() => onPageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className="p-2 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <ChevronLeft className="w-5 h-5 text-gray-600" />
    </button>
    <div className="flex items-center gap-1">
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          onClick={() => onPageChange(i + 1)}
          className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm transition-colors ${
            currentPage === i + 1
              ? "bg-[#FF6C6C] text-white"
              : "hover:bg-gray-100 text-gray-600"
          }`}
        >
          {i + 1}
        </button>
      ))}
    </div>
    <button
      onClick={() => onPageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      className="p-2 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <ChevronRight className="w-5 h-5 text-gray-600" />
    </button>
  </div>
);
export default Pagination;